
import { Vue, Component, Ref } from 'vue-property-decorator'
import { cloneDeep } from 'lodash-es'
import { FormModel } from 'ant-design-vue'
import PublicForm from '@/components/public-form/PublicForm.vue'
import PublicFormItem from '@/components/public-form/PublicFormItem.vue'
import type { FeedBackInputDto } from '@/api/swagger'
import Uploader from '@/components/uploader/index.vue'

type IForm = FeedBackInputDto

type ConfirmCallback = () => void

enum FeedbackType {
  /**
   * 建议
   */
  Advise = 1,
  /**
   * 投诉
   */
  Complain = 2,
}

@Component({
  name: 'FeedbackModel',
  components: {
    Uploader,
    PublicForm,
    PublicFormItem,
  },
})
export default class FeedbackModel extends Vue {
  @Ref('ruleForm')
  private ruleForm!: FormModel

  private visible = false
  private submitLoading = false

  private get feedbackTypeEnum() {
    return FeedbackType
  }

  private defaultForm: IForm = {
    id: undefined,
    content: '',
    type: FeedbackType.Advise,
    file: [],
  }
  private formModel: IForm = cloneDeep(this.defaultForm)

  public show(params?: { onOk?: ConfirmCallback }) {
    this.visible = true
    if (params?.onOk && typeof params.onOk === 'function') {
      this.successCallback = params.onOk
    }
  }

  private changeFiles(files) {
    this.formModel.file = files.map((item) => ({
      fileCode: item.fileCode || item.code,
      fileName: item.fileName,
    }))
  }

  private submitForm() {
    if (this.submitLoading) return
    this.ruleForm.validate((valid) => {
      if (!valid) return
      this.submitLoading = true

      this.$http
        .post('/api/Feedback/ProvideFeedBack', this.formModel)
        .then(() => {
          this.$message.success('提交成功')
          this.visible = false
          if (typeof this.successCallback === 'function') this.successCallback()
        })
        .catch((err) => {
          this.$message.error(err.message || '提交失败')
        })
        .finally(() => {
          this.submitLoading = false
        })
    })
  }

  private successCallback?: ConfirmCallback | null = null

  private afterClose() {
    this.formModel = cloneDeep(this.defaultForm)
    this.submitLoading = false
    this.successCallback = null
    this.ruleForm.clearValidate([])
  }
}
